import { Collapse } from 'antd';
import styled from 'styled-components';

export const StyledCollapse = styled(Collapse)`
  .ant-collapse-item {
    .ant-collapse-header {
      border-radius: var(--borderRadius) !important;
      border-bottom: 1px solid var(--borderColor);
      background-color: var(--colorBgContainer);
      align-items: center;
      height: 56px;
      padding: 0 24px;

      .ant-collapse-header-text {
        display: flex;
        align-items: center;
        gap: 8px;
        font-size: 16px;
        font-weight: 500;
        line-height: 1;
      }
    }
  }

  .ant-collapse-item-active {
    .ant-collapse-header {
      border-radius: var(--borderRadius) var(--borderRadius) 0 0 !important;
    }
  }

  .ant-collapse-content {
    border-top: none;
  }
`;
